/* import __COLOCATED_TEMPLATE__ from './learn-button.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export default class LearnButton extends Component {
  @service declare intercomEventService: $TSFixMe;
  @service declare intl: IntlService;

  @action openArticleAndTrack(articleId: number, trackingObject: string) {
    window.Intercom('showArticle', articleId);
    this.trackDropdownClick(trackingObject);
  }

  get dropdownItems() {
    return [
      {
        text: this.intl.t('reporting.overview.learn-dropdown.reports-explained'),
        icon: 'article',
        onSelectItem: () => this.openArticleAndTrack(200, 'reports-explained'),
      },
      {
        text: this.intl.t('reporting.overview.learn-dropdown.reporting-datasets'),
        icon: 'article',
        onSelectItem: () => this.openArticleAndTrack(8825260, 'reporting-datasets'),
      },
      {
        text: this.intl.t('reporting.overview.learn-dropdown.fin-ai-agent-reporting'),
        icon: 'article',
        onSelectItem: () => this.openArticleAndTrack(7837533, 'fin-ai-agent-reporting'),
      },
      {
        text: this.intl.t('reporting.overview.learn-dropdown.custom-report'),
        icon: 'article',
        onSelectItem: () => this.openArticleAndTrack(4549035, 'custom-report'),
      },
    ];
  }

  @action trackDropdownClick(name: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: name,
      place: 'learn-dropdown',
      section: 'reporting',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::InContext::StaticReport::LearnButton': typeof LearnButton;
    'reporting/in-context/static-report/learn-button': typeof LearnButton;
  }
}
